import Image from 'next/image'
import { Drawer } from 'antd'
import { useRouter } from 'next/router'
import { webAssets } from '../../utils/webAssets'

import MenuContent from './homeLayout/MenuContent'

export default function MobileSideNav({ open, setOpen, children }) {
  const router = useRouter()

  const content = children || <MenuContent setOpen={setOpen} />

  return (
    <Drawer
      className='sidenav-drawer'
      title={null}
      placement='left'
      width={293}
      zIndex={100000}
      onClose={() => setOpen(false)}
      open={open}
      closable={false}
    >
      <div className='text-center mb-32'>
        <Image
          alt='smartcaf-logo'
          width={86}
          height={60}
          src={webAssets.logoDark}
          preview={false}
          className='mx-auto cursor-pointer'
          onClick={() => {
            router.push('/')
            setOpen(false)
          }}
        />
      </div>
      {content}
    </Drawer>
  )
}
